const HTTPClient = require('./libs/HTTPClient');

const BaseModel = require('./libs/Models/BaseModel');

const Aggregates = require('./libs/Models/Aggregates');
const Answer = require('./libs/Models/Answer');
const BaseEntityFilter = require('./libs/Models/EntityFilter/BaseEntityFilter');
const BillingPlan = require('./libs/Models/Billing/Plan');
const BillingInvoice = require('./libs/Models/Billing/Invoice')
const Branding = require('./libs/Models/Branding');
const Channel = require('./libs/Models/Channel');
const ChannelTemplate = require('./libs/Models/ChannelTemplate');
const Company = require('./libs/Models/Company');
const Contact = require('./libs/Models/Contact');
const Dashboard = require('./libs/Models/Dashboard');
const Email = require('./libs/Models/Email');
const EmailLayoutTemplate = require('./libs/Models/EmailLayoutTemplate');
const Entity = require('./libs/Models/Entity');
const EntityGroup = require('./libs/Models/EntityGroup');
const EntityFilter = require('./libs/Models/EntityFilter');
const Flow = require('./libs/Models/Flow');
const FlowInstance = require('./libs/Models/FlowInstance');
const FlowInstanceQuestion = require('./libs/Models/FlowInstanceQuestion');
const FlowNudge = require('./libs/Models/FlowNudge');
const MessageTemplate = require('./libs/Models/MessageTemplate');
const Organisation = require('./libs/Models/Organisation');
const OrganisationEntitlement = require('./libs/Models/Organisation/OrganisationEntitlement')
const Question = require('./libs/Models/Question');
const Reward = require('./libs/Models/Reward');
const RewardGrant = require('./libs/Models/Reward/RewardGrant');
const RewardProvider = require('./libs/Models/Reward/RewardProvider');
const Survey = require('./libs/Models/Survey');
const User = require('./libs/Models/User');
const UserGroup = require('./libs/Models/UserGroup');

const parseModel = BaseModel.parse;

module.exports = {
  HTTPClient, Aggregates, Answer,
  BaseEntityFilter, BillingPlan, BillingInvoice, Branding, Channel, ChannelTemplate, Company, Contact,
  Dashboard, Email, EmailLayoutTemplate, Entity, EntityFilter, EntityGroup,
  Flow, FlowInstance, FlowInstanceQuestion, FlowNudge, MessageTemplate, Question, Survey, User, UserGroup,
  Reward, RewardGrant, RewardProvider,
  Organisation, OrganisationEntitlement,
  parseModel
}

